import { CONTACT_EMAIL } from "./constants";

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function brandHeader(): string {
  return `
    <header class="brand" aria-label="Locket">
      <a href="/" class="brand-link">
        <div class="brand-mark" aria-hidden="true">✦</div>
        <p class="brand-name">Locket</p>
        <p class="brand-tag">Memories &amp; Storybook</p>
      </a>
    </header>
  `;
}

export function siteFooter(): string {
  return `
    <footer class="footer site-footer">
      <nav class="site-nav" aria-label="Site links">
        <a href="/privacy">Privacy</a>
        <span class="site-nav-sep" aria-hidden="true">·</span>
        <a href="/terms">Terms</a>
        <span class="site-nav-sep" aria-hidden="true">·</span>
        <a href="/contact">Contact</a>
      </nav>
      <p class="footer-tagline">Questions? <a href="mailto:${escapeHtml(CONTACT_EMAIL)}">${escapeHtml(CONTACT_EMAIL)}</a></p>
    </footer>
  `;
}

export function siteShell(inner: string, options?: { wide?: boolean }): string {
  const cardClass = options?.wide ? "card site-card site-card--wide" : "card site-card";
  return `
    <div class="page">
      <div class="page-texture" aria-hidden="true"></div>
      <main class="${cardClass}" role="main">
        ${brandHeader()}
        ${inner}
      </main>
      ${siteFooter()}
    </div>
  `;
}
